import React from "react";

const ErrorPage = () => {
  return (
    <div>
      <h1>thats error page</h1>
    </div>
  );
};

export default ErrorPage;
